import React from 'react'
import loadable from '@loadable/component';
import { Route, Switch } from 'react-router-dom';

import './custom.css';

const CustomMenuContentPage = loadable(() => import('./CustomMenuContentPage'));
const CreateOrEditCustomMenu = loadable(() => import('./CreateOrEditCustomMenu'));

const MenuPlaceholder = () => {
    return (
        <Switch>
            <Route path="/settings/menuPlaceholders/rec" exact component={CreateOrEditCustomMenu} />
            <Route path="/settings/menuPlaceholders/list" exact component={CustomMenuContentPage} />            
            <Route path="/" component={CustomMenuContentPage} />
        </Switch>
    )
}

export default MenuPlaceholder